module.exports = __webpack_public_path__ + "static/media/icon-casinodollars.76f657b1.png";